<template>
  <div>
    <div class="pt-24 lg:px-20 md:px-10 px-5">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="fsize16">Resources</el-breadcrumb-item>
        <el-breadcrumb-item class="fsize16">Heart of Care</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div
      class="lg:flex md:flex gap-5 lg:px-20 md:px-10 px-5 lg:pb-0 md:pb-0 pb-10 lg:pt-20 md:pt-20 pt-10"
    >
      <div class="lg:w-1/2 md:w-1/2 lg:pb-0 md:pb-0 pb-2">
        <div class="flex gap-5">
          <p class="title-semibold fsize36-24px">
            Welcome to <br />
            HeArt of Care
          </p>
          <img
            src="@/assets/images/heartOfCare/heartofcare.png"
            alt="bg-polygon1"
            class="custborderradius lg:w-36 md:w-36 w-20 lg:h-32 md:h-32 h-20"
          />
        </div>
        <!-- <p class="joinus-subtitle md:pt-10 lg:pt-10 pt-4 fsize24-14px"> -->
        <p class="subtitle lg:pt-10 md:pt-10 pt-2 lh32px sm-lh26 sm-fsize13">
          The HeArt of Care is an international alliance of organisations who
          are working together to raise awareness of the role of carers in our
          societies.
          <!-- <div class="md:pt-10 lg:pt-10 pt-6">
            <base-button
              type="primary"
              class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 font-semibold border-2 fsize24-14px"
            >
              <a
                target="_blank"
                class="hover:text-white"
                href="https://forms.office.com/r/vctepmjfcA"
                >Know More</a
              ></base-button
            >
          </div> -->
        </p>
      </div>
      <div class="lg:w-1/2 md:w-1/2">
        <!-- <img
        src="https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/2.jpg"
        alt="bg-polygon1"
        class="custborderradius"
      /> -->
        <iframe
          class="custborderradius videoheART"
          width="560"
          height="315"
          src="https://www.youtube.com/embed/3c9fkipH8H8"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
        <!-- <img
        src="@/assets/images/heartOfCare/heartofcare.png"
        alt="bg-polygon1"
        class="custborderradius m-auto"
      /> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
      this.toggleNavbar();
    },
  },
};
</script>
<style>
.custimgsize {
  width: 562px;
  margin: auto;
  top: 145px;
}

@media (max-width: 640px) {
  .custimgsize {
    width: 343px;
    margin: auto;
    top: 276px;
  }
  .videoheART {
    width: -webkit-fill-available;

    height: 200px;
  }
}
</style>
